// src/components/SessionWarningBanner.js
import React from "react";
import { useAuth } from "../context/AuthContext";

export default function SessionWarningBanner() {
  const { sessionWarning, extendSession, logout } = useAuth();

  if (!sessionWarning) return null;

  return (
    <div style={{
      position:        "fixed",
      top:             0,
      left:            0,
      right:           0,
      zIndex:          9999,
      backgroundColor: "#1F4E79",
      color:           "#fff",
      padding:         "14px 24px",
      display:         "flex",
      alignItems:      "center",
      justifyContent:  "space-between",
      fontFamily:      "Arial, sans-serif",
      fontSize:        "14px",
      boxShadow:       "0 2px 8px rgba(0,0,0,0.3)",
    }}>
      <span>⏱ Your session will expire in 1 minute due to inactivity.</span>
      <div style={{ display: "flex", gap: "12px" }}>
        <button
          onClick={extendSession}
          style={{
            backgroundColor: "#fff",
            color:           "#1F4E79",
            border:          "none",
            padding:         "6px 16px",
            borderRadius:    "4px",
            cursor:          "pointer",
            fontWeight:      "bold",
            fontSize:        "13px",
          }}
        >
          Stay Logged In
        </button>
        <button
          onClick={() => logout("manual")}
          style={{
            backgroundColor: "transparent",
            color:           "#ccc",
            border:          "1px solid #ccc",
            padding:         "6px 16px",
            borderRadius:    "4px",
            cursor:          "pointer",
            fontSize:        "13px",
          }}
        >
          Log Out Now
        </button>
      </div>
    </div>
  );
}